<!-- <template>
  <router-view />
</template>

<script>
import "@/assets/css/style.css";
import Swal from "sweetalert2";

export default {
  data() {
    return {
      deferredPrompt: null,
    };
  },
  mounted() {
    window.addEventListener("beforeinstallprompt", (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
      console.log("beforeinstallprompt event fired");
      this.showInstallPrompt();
    });
  },
  methods: {
    showInstallPrompt() {
      Swal.fire({
        title: "نصب برنامه",
        text: "می‌خواهید این برنامه را نصب کنید؟",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "بله، نصب کن",
        cancelButtonText: "نه، بعداً",
      }).then((result) => {
        if (result.isConfirmed) {
          this.deferredPrompt.prompt();
          this.deferredPrompt.userChoice.then((choiceResult) => {
            if (choiceResult.outcome === "accepted") {
              Swal.fire("نصب شده!", "برنامه با موفقیت نصب شد.", "success");
            } else {
              Swal.fire("نصب لغو شد", "شما می‌توانید بعداً نصب کنید.", "error");
            }
            this.deferredPrompt = null;
          });
        }
      });
    },
  },
};
</script> -->
<template>
  <div class="bg-white dark:bg-black">
    <router-view />
  </div>
</template>

<script>
import "@/assets/css/style.css";
// import Swal from "sweetalert2";

export default {
  // data() {
  //   return {
  //     deferredPrompt: null,
  //   };
  // },
  // mounted() {
  //   window.addEventListener("beforeinstallprompt", (event) => {
  //     event.preventDefault();
  //     this.deferredPrompt = event;
  //     console.log("beforeinstallprompt event fired");
  //     this.showInstallPrompt();
  //   });
  // },
  // methods: {
  //   showInstallPrompt() {
  //     Swal.fire({
  //       title: false,
  //       text: "کاربری بهینه تر و دسترسی آسان به برنامه، بعدا نیز میتوانید از طریق add to home screen برنامه را نصب نمائید",
  //       imageUrl: require("@/assets/images/logo.png"),
  //       imageWidth: 100,
  //       imageHeight: 100,
  //       showCancelButton: true,
  //       confirmButtonText: "بله، نصب کن",
  //       cancelButtonText: "نه، بعداً",
  //       customClass: {
  //         confirmButton: "confirm-btn",
  //         cancelButton: "cancel-btn",
  //       },
  //     }).then((result) => {
  //       if (result.isConfirmed) {
  //         this.deferredPrompt.prompt();
  //         this.deferredPrompt.userChoice.then((choiceResult) => {
  //           if (choiceResult.outcome === "accepted") {
  //             Swal.fire({
  //               title: false,
  //               text: "برنامه با موفقیت نصب شد.",
  //               icon: "success",
  //               confirmButtonText: "تایید",
  //               customClass: {
  //                 confirmButton: "confirm-btn",
  //               },
  //             });
  //           } else {
  //             Swal.fire({
  //               title: false,
  //               text: "شما می‌توانید بعداً نصب کنید.",
  //               icon: "error",
  //               confirmButtonText: "تایید",
  //               customClass: {
  //                 confirmButton: "confirm-btn",
  //               },
  //             });
  //           }
  //           this.deferredPrompt = null;
  //         });
  //       }
  //     });
  //   },
  // },
};
</script>

<style>
.div:where(.swal2-container).swal2-center>.swal2-popup {
  border-radius: 10px 0;
}

div:where(.swal2-container) div:where(.swal2-popup) {
  padding: 0 0 0.5em;
}

.swal2-actions {
  flex-wrap: nowrap;
}

.swal2-actions {
  width: 100%;
}

.confirm-btn {
  background-color: #39b449;
  color: white;
  border-radius: 10px 0;
  font-weight: 400;
  width: 100%;
}

.cancel-btn {
  background-color: #335d9d;
  color: white;
  border-radius: 10px 0;
  font-weight: 400;
  width: 100%;
}

.confirm-btn:hover {
  background-color: #45a049;
}

.cancel-btn:hover {
  background-color: #2a4a7a;
}
</style>
